module.exports = __webpack_public_path__ + "img/Menu-17.59ec1a6c.webp";